import { useQuery, useMutation } from '@tanstack/react-query';
import userService from 'api/userService';

export const useAdminAllRiders = (params) => {
    return useQuery({
        queryKey: ['adminAllRiders', params],
        queryFn: () => userService.adminGetAllRiders(params)
        // keepPreviousData: true,
        // staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useAdminRiderDetails = (riderId) => {
    return useQuery({
        queryKey: ['adminRiderDetails', riderId],
        queryFn: () => userService.getRiderById(riderId)
        // staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};
export const useAdminRiderKYC = (userId) => {
    return useQuery({
        queryKey: ['adminRiderDetails', userId],
        queryFn: () => userService.adminGetUserKYC(userId),
        enabled: !!userId
        // staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useUpdateRiderStatus = (riderId) => {
    return useMutation({
        queryKey: ['adminRiderDetails', riderId],
        queryFn: () => userService.getRiderDetails(riderId)
        // staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useAdminUpdateRider = () => {
    return useMutation({
        mutationFn: ({ id, payload }) => userService.adminUpdateRider(id, payload)
    });
};
